"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Icon = undefined;

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Icon = exports.Icon = function Icon(props) {
  var className = props.className,
      icon = props.icon,
      style = props.style;


  return _react2.default.createElement("i", {
    className: (0, _classnames2.default)("erg-components-Icon", "fa", "fa-" + icon, className),
    style: style });
};

Icon.displayName = "Icon";

Icon.propTypes = {
  className: _propTypes2.default.string,
  icon: _propTypes2.default.string.isRequired,
  style: _propTypes2.default.object
};

exports.default = Icon;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@ergeon/erg-components-react/lib/Icon.js
 ** module id = 161
 ** module chunks = 0
 **/